import localFont from "next/font/local";
import { LATO_VARIABLE_CLASS } from "./fontConstants";

const latoLatin = localFont({
  src: [
    {
      path: "../../public/fonts/lato-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../public/fonts/lato-italic.woff2",
      weight: "400",
      style: "italic",
    },
    {
      path: "../../public/fonts/lato-bold.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  declarations: [
    {
      prop: "font-family",
      value: "Lato",
    },
    {
      prop: "unicode-range",
      value:
        "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
  ],
  preload: false,
  variable: "--font-lato-latin",
});

const latoLatinExt = localFont({
  src: [
    {
      path: "../../public/fonts/lato-light.woff2",
      weight: "300",
      style: "normal",
    },
    {
      path: "../../public/fonts/lato-regular-ext.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../public/fonts/lato-bold-ext.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  declarations: [
    {
      prop: "font-family",
      value: "Lato",
    },
    {
      prop: "unicode-range",
      value:
        "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
  ],
  preload: false,
  variable: "--font-lato-latin-ext",
});

// https://nextjs.org/docs/app/getting-started/fonts
// Prevent layout change of fonts by using localFont
export const raleway = localFont({
  src: [
    {
      path: "../../public/fonts/raleway-light.woff2",
      weight: "300",
      style: "normal",
    },
    {
      path: "../../public/fonts/raleway-regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "../../public/fonts/raleway-heavy.woff2",
      weight: "500",
      style: "normal",
    },
    {
      path: "../../public/fonts/raleway-semi-bold.woff2",
      weight: "600",
      style: "normal",
    },
    {
      path: "../../public/fonts/raleway-bold.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  preload: false,
  variable: "--font-raleway",
});

export const lato = {
  variable: `${latoLatin.variable} ${latoLatinExt.variable} ${LATO_VARIABLE_CLASS}`,
} as const;
